export {
  materialsGetElementDetail,
  materialsGetHistoryElementDetail,
} from '@/app/services/vidu';
